import React, { Component } from 'react';
import { observer } from 'mobx-react';
import RecordLine from 'Components/ProtocolView/recordLine';
import RecordLineHeader from 'Components/ProtocolView/recordLineHeader';
import 'Styles/protocolView/protocol.scss';
import ProtocolRecordsStore from 'Stores/ProtocolRecords/protocolRecordsStore';
import FiltersStore from 'Stores/ProtocolRecords/FiltersStore';
import SmrTable from "Components/Common/SmrTable";
import FiltersPanel from "Components/ProtocolView/filtersPanel";
import MultiButton from "Components/Common/multiButton";
import TransparentLoadIndicator from "Components/Common/transparentLoadIndicator";
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import { ShowModal, ShowAlert } from "Utils/CommonFunctions";
import CheckboxWithText from "Components/Common/CheckboxWithText";
import FiltersSimplePanel from "Components/Common/FiltersPanel/FiltersSimplePanel";
import IconsContainer from 'Utils/IconsContainer';
import Popup2 from 'Components/Common/Popup2';

class ProtocolRecords extends Component {

    componentDidMount() {
        AppStore.OnMainComponentMount('Протоколирование', 'protocolRecords', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        ProtocolRecordsStore.ClearStore();
        FiltersStore.ClearStore();
    }

    ReloadData() {
        ProtocolRecordsStore.ClearStore();
        FiltersStore.GetInitData();
        ProtocolRecordsStore.GetData();
    }

    renderTableLine(item) {
        return <RecordLine record={item}
            key={`record-line-${item.id}`} />;
    }

    renderHeader() {
        return <RecordLineHeader />;
    }

    RenderArchiveState() {
        if (!ProtocolRecordsStore.state.inProcess)
            return '';

        return (
            <TransparentLoadIndicator processInfo={{
                inProgress: ProtocolRecordsStore.state.inProcess,
                progress: ProtocolRecordsStore.state.clearProgress
            }} text="Архивация протокола" />
        );
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        var isNoRecordsOrLoading = ProtocolRecordsStore.recordsLoading || ProtocolRecordsStore.records.length === 0;

        let buttonsPanel = {
            left: [
                <span className='selected-records-title'>
                    {'Выбрано записей: ' + ProtocolRecordsStore.selectedRecordsIds.length}
                </span>
                ,
                <MultiButton title='Сохранить'
                    id='save-button'
                    buttons={[{
                        disabled: isNoRecordsOrLoading,
                        title: 'Выгрузить с учетом фильтров',
                        onClick: ProtocolRecordsStore.PrintFilteredLogs.bind(ProtocolRecordsStore)
                    }, {
                        disabled: ProtocolRecordsStore.selectedRecordsIds.length == 0,
                        title: 'Выгрузить выделенное',
                        onClick: ProtocolRecordsStore.PrintSelectedLogs.bind(ProtocolRecordsStore)
                    }]}
                    key={'protocol-multi-button'}
                />
            ]
            ,
            right:
                [
                    <div style={{ alignContent: 'center', marginRight: '5px' }}>
                        <Popup2
                            popupText="Будет выгружена информация о сервере мобильных решений и его окружении"
                            isTop={true}
                            textAlignIsLeft={false}>
                            {IconsContainer.Get('ci-info')}
                        </Popup2>
                    </div>
                    ,
                    <button
                        id="clear-button"
                        key='protocol-print-environment'
                        onClick={() => ProtocolRecordsStore.PrintEnvironment()}
                        className={(ProtocolRecordsStore.printEnvironmentRequested ? 'disabled' : '')}>
                        Выгрузить окружение
                    </button>
                ]
        };

        return (
            <div className="protocol-records">
                <FiltersSimplePanel
                    className={(FiltersStore.initDataLoading ? ' disabled' : '')}
                    getFiltersRender={() => FiltersStore.filtersRender}
                    getFilters={() => FiltersStore.filters}
                    clearFilters={() => {
                        FiltersStore.ClearFiltersRender();
                        FiltersStore.SaveFiltersFromRender();
                        ProtocolRecordsStore.GetData(1, true);
                    }}
                    visibleFiltersFieldNames={["regNumAlias", "matchWholeWord"]}
                    search={() => ProtocolRecordsStore.GetData(1, true)}
                    getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                    showFullFilters={() => {
                        ShowModal({
                            className: "filters-modal",
                            canBeClosed: true,
                            blockProductSwitcher: true,
                            header: 'Фильтрация данных',
                            children: (<FiltersPanel />),
                            buttons:
                                [
                                    {
                                        content: 'Очистить',
                                        closer: false,
                                        onClick: _ => FiltersStore.ClearFiltersRender()
                                    }, {
                                        content: 'Применить',
                                        closer: true,
                                        className: "blue-button",
                                        onClick: _ => {
                                            FiltersStore.SaveFiltersFromRender();
                                            ProtocolRecordsStore.GetData(1, true);
                                        }
                                    }
                                ],
                            width: '480px',
                            height: "90%"
                        });
                    }}
                    getAdditionalFiltersContols={() => [
                        FiltersStore.filtersValues.isVisibleControlCbModeIsCanViewBoxLogRecords != true ? null : (
                            <CheckboxWithText
                                checked={FiltersStore.filters.cbProtocolShowBoxRecords}
                                onChange={(checked) => {
                                    ProtocolRecordsStore.SaveSettingCbProtocolShowBoxRecords(checked);
                                    FiltersStore.filters.cbProtocolShowBoxRecords = checked;
                                    ProtocolRecordsStore.GetData(1);
                                }}
                                text="Расширенное протоколирование"
                            />
                        )
                    ]}
                />
                <SmrTable
                    renderTableLine={this.renderTableLine.bind(this)}
                    loading={ProtocolRecordsStore.recordsLoading}
                    loadText="Выполняется поиск. Пожалуйста, подождите..."
                    renderHeader={this.renderHeader.bind(this)}
                    getDataPage={ProtocolRecordsStore.GetData.bind(ProtocolRecordsStore)}
                    location={this.props.location}
                    buttonsPanel={buttonsPanel}
                    setTableStore={ProtocolRecordsStore.SetTableStore.bind(ProtocolRecordsStore)}
                    rowHeight={71}
                />
                {this.RenderArchiveState()}
            </div>
        );
    }
}

export default observer(ProtocolRecords);